import { defineAsyncComponent } from 'vue'

export default [
  {
    path: '/consent-mobile',
    name: 'consent-mobile',
    meta: {
      useSmartlook: true,
    },
    component: defineAsyncComponent(() => import('@/views/consent-mobile/index.vue')),
  },
]
